<template>
  <div class="camp-payment-pagearea primary-page">
      <section class="wrapper series-data-box">
        <div class="name">{{ seriesData.name }}</div>
        <div class="num-nd-date">
          第{{ seriesData.camp_num + 1 }}期  开营时间：{{ seriesData.training_date }}
        </div>
        <div class="cover-zone">
          <img class="cover-img" :src="seriesData.teacher_image" alt="" >
        </div>
      </section>

      <section class="wrapper price-wrapper">
        <div class="common">
          <div class="subs">训练营价格</div>
          <div class="order-info normal-price">{{ seriesData.original_price || seriesData.price }}</div>
        </div>
        <div class="common" v-if="seriesData.original_price && (seriesData.original_price > seriesData.price)">
          <div class="subs">早鸟优惠</div>
          <div class="order-info discount">-{{ seriesData.original_price - seriesData.price }}</div>
        </div>
        <div class="common" v-if="vouchers && vouchers.length" @click.stop="showVouchersDialog=true;" v-cloak>
          <div class="subs">优惠券</div>
          <div v-if="!currentVoucher.id" class="order-info voucher no-use">不使用优惠券</div>
          <div v-else-if="currentVoucher.discount_money > 0" class="order-info voucher">-{{ currentVoucher.discount_money }}</div>
        </div>
        <div class="real-pay">
          实付：<span class="real-pay-money">{{ realPayMoney }}</span>
        </div>
      </section>

      <ul class="wrapper payment-type-wrapper">
        <li class="item wechat" :class="{ selected: currentPayType === MONEY_TYPE_WECHAT }" @click.stop="currentPayType = MONEY_TYPE_WECHAT">
          <span>微信支付</span>
        </li>
        <li class="item alipay" :class="{ selected: currentPayType === MONEY_TYPE_ALIPAY }" @click.stop="currentPayType = MONEY_TYPE_ALIPAY">
          <span>支付宝支付</span>
        </li>
        <li v-if="seriesData.installment && seriesData.installment.enable" class="item huabei" :class="{ selected: currentPayType === MONEY_TYPE_HUABEI }" @click.stop="currentPayType = MONEY_TYPE_HUABEI">
          <span>花呗免息分期</span>
          <template v-if="currentVoucher.hb_fq_nums_12 === true">
            <div class="detail">
              <a class="fenqi" :class="{selected: currentFenQi === 6}" @click.stop="currentFenQi = 6" style="margin-right: 10px">
                <div>6期免息</div>
                <div><span>{{ amountPerPeriod(6) }}</span><span style="color: #c3c4c5"> x6期</span></div>
              </a>
              <a class="fenqi" :class="{selected: currentFenQi === 12}" @click.stop="currentFenQi = 12">
                <div>12期免息</div>
                <div><span>{{ amountPerPeriod(12) }}</span><span style="color: #c3c4c5"> x12期</span></div>
              </a>
            </div>
          </template>
          <template v-else>
            <div class="detail">
              <span>{{ amountPerPeriod(seriesData.installment.hb_fq_nums) }}</span>x{{ seriesData.installment.hb_fq_nums }}期（免手续费）
            </div>
          </template>
        </li>
        <li v-if="seriesData.unionpay_installment && seriesData.unionpay_installment.enable" class="item unionpay" :class="{ selected: currentPayType === MONEY_TYPE_UNIONPAY_INSTALLMENT }" @click.stop="currentPayType = MONEY_TYPE_UNIONPAY_INSTALLMENT">
          <span>银联免息分期</span>
          <div class="detail">
            <span>{{ unionpayPerPeriod }}</span>x{{ seriesData.unionpay_installment.nums }}期（免手续费）
          </div>
        </li>
      </ul>

      <section class="page-footer">
        <div class="service-agreement" v-if="!!agreementUrl" :class="{ selected: agree }" @click="agree = !agree">
          已阅读并同意
          <a class="link" :href="agreementUrl">
            《训练营服务协议》
          </a>
        </div>
        <div class="pay-btn">
          <span class="text" @click.stop="submitPurchase">立即支付</span>
        </div>
      </section>

      <!-- 弹窗：选择优惠券 -->
      <van-action-sheet class="vouchers-dialog" safe-area-inset-bottom v-model="showVouchersDialog" title="选择优惠券">
        <ul class="voucher-list">
          <li class="v-item" @click.prevent.stop="selectVoucher()">
              <div class="single-voucher-wrap" :class="{on:!currentVoucher.id}">
                  <div class="voucher-name">
                      <span>不使用优惠券</span>
                  </div>

                  <i class="icon-select"></i>
              </div>
          </li>
          <template v-for="(item, index) in vouchers">
              <li class="v-item" :key="index">
                  <div class="v-bg-zone not-box-shadow">
                      <img src="@/common/images/coupon_normal.png" alt="" class="v-bg-img">
                  </div>
                  <a class="single-voucher-wrapper" href="javascript:;" @click.prevent.stop="selectVoucher(item)">
                      <div class="v-left-wrap">
                          <p class="voucher-value" v-if="item.discount_money" v-cloak>¥<strong class="num" v-text="item.discount_money"></strong></p>
                          <!-- <p class="voucher-value" v-else-if="item.discount_ratio" v-cloak><strong class="num" v-text="item.discount_ratio*10+'折'"></strong></p> -->
                      </div>
                      <div class="v-right-zone series-select" :class="{on: currentVoucher.id == item.id}">
                          <h4 class="voucher-name" v-text="item.show_title"></h4>
                          <div class="vocher-info-zone">
                              <p class="i-item" v-text="item.show_deadline_date"></p>
                              <p class="i-item" v-text="item.show_desc"></p>
                          </div>
                      </div>
                  </a>
              </li>
          </template>
        </ul>
      </van-action-sheet>

      <!-- 弹窗：支付二维码 -->
      <van-overlay :show="showWithdrawDia">
        <div class="dialog-wrapper withdraw-dialog" @click.self="showWithdrawDia = false">
          <div class="withdraw-box">
            <div class="tell">请扫描识别二维码进行付款</div>
            <div class="money">支付金额：<span class="num">{{ money }}</span>元</div>
            <img class="qrcode" :src="qrcodeImage" v-if="qrcodeImage.indexOf('data:image/png;') === 0" />
            <div class="qrcode" v-else>
              <iframe :src="qrcodeImage" scrolling="no" title="alipay qrcode" width="210" height="210"></iframe>
            </div>
          </div>
        </div>
      </van-overlay>
  </div>
</template>

<script>
// import Vue from 'vue';
import { Overlay, ActionSheet, Toast } from 'vant';
import Cookies from 'js-cookie';
import {
  MONEY_TYPE_WECHAT,
  MONEY_TYPE_ALIPAY,
  MONEY_TYPE_HUABEI,
  MONEY_TYPE_UNIONPAY_INSTALLMENT
} from '@/common/js/config';
import payment from '@/mixin/payment';
import { initWxConfig } from '@/config/wxConfig';
import {
  // eslint-disable-next-line camelcase
  getLessonSeriesDetail_v4_0,
  getLessonVoucher,
  getUserViewData,
  serviceAgreement,
  enterPurchaseDynamic
} from '@/api/api';
import {
  deleteParam,
  isIos
} from '@/common/js/utils';


// Vue.use(Overlay);
// Vue.use(ActionSheet);
// Vue.use(Toast);

const GENERAL_VOUCHER_FLAG = 0; // 普通优惠券/通用券
const APP_VOUCHER_FLAG = 1; // app 专用/app专属券
const VIP_VOUCHER_FLAG = 2; // 会员专用/vip专属券
const APP_VIP_VOUCHER_FLAG = 4; // app 会员专属/VIP的APP专属券
const TRAINING_VOUCHER_FLAG = 8; // 训练营专属/训练营专属券
const INVITE_VOUCHER_TYPE = 38;

export default {
  mixins: [payment],
  components: {
    [Overlay.name]: Overlay,
    [ActionSheet.name]: ActionSheet
  },
  data() {
    return {
      MONEY_TYPE_WECHAT,
      MONEY_TYPE_ALIPAY,
      MONEY_TYPE_HUABEI,
      MONEY_TYPE_UNIONPAY_INSTALLMENT,
      currentPayType: MONEY_TYPE_WECHAT,
      currentFenQi: 6,

      agree: false,
      appId: 2,
      money: 0,
      showWithdrawDia: false,
      qrcodeImage: '',
      ordering: false,

      showVouchersDialog: false,

      seriesId: 0,
      seriesData: {},
      userViewData: {},

      vouchers: {},
      currentVoucher: {},
      discountRatioMoney: 0,

      // 渠道id（分销id）
      salelinkId: 0,
      agreementUrl: '',
    };
  },
  computed: {
    voucherDiscountMoney() {
      if (!this.currentVoucher.id) {
        return 0;
      }
      if (this.currentVoucher.discount_money) {
        return this.currentVoucher.discount_money;
      }
      return 0;
    },
    realPayMoney() {
      let ret = this.seriesData.price
          - this.voucherDiscountMoney;
      ret = parseFloat(ret.toFixed(2));
      ret = Math.max(0, ret);
      return ret;
    },
    unionpayPerPeriod() {
      // 银联分期每期应还金额
      let ret = 0;
      if (this.seriesData.unionpay_installment && this.seriesData.unionpay_installment.enable) {
        ret = `${(Math.floor((this.realPayMoney * 100) / this.seriesData.unionpay_installment.nums) / 100).toFixed(2)}`;
      }
      return ret;
    },
  },
  created() {
    // 此页面禁止分享和复制链接
    // eslint-disable-next-line no-underscore-dangle
    this.appId = +this.$route.query._app_id || this.appId;
    initWxConfig(this.appId).then(() => {
      // eslint-disable-next-line no-undef
      wx.hideMenuItems({
        menuList: [
          'menuItem:share:appMessage',
          'menuItem:share:timeline',
          'menuItem:share:qq',
          'menuItem:share:weiboApp',
          'menuItem:share:facebook',
          'menuItem:share:QZone',
          'menuItem:copyUrl'
        ]
      });
    });

    this.seriesId = +this.$route.params.series_id;
    this.salelinkId = +this.$route.query.sale_link_id || 0;
    const userId = Cookies.get('user_id');

    if (!userId) {
      let redirectUrl = null;
      if (this.salelinkId) {
        redirectUrl = `/camp-order/${this.$route.params.series_id}?sale_link_id=${this.salelinkId}`;
      } else {
        redirectUrl = `/camp-order/${this.$route.params.series_id}`;
      }
      this.$router.replace({
        path: '/login',
        query: { redirect: redirectUrl },
      });
      return;
    }

    this.querySeriesDetail();
    this.queryVouchers();

    // 记录进入页面的用户动态
    this.recordEnterPurchasePage();

    // [mweb支付] 没有完成支付
    window.windowOnPaidFail = () => {
      console.log('没有完成支付咯！');
    };

    // [mweb支付] 完成支付
    window.windowOnPaidSuccess = () => {
      let hrefUrl = window.location.href;
      hrefUrl = deleteParam(hrefUrl, 'purchase_id');
      window.history.replaceState(null, null, hrefUrl);
      this.$router.replace({
        name: 'camp-learning',
        params: {
          series_id: this.seriesId
        },
        query: {
          show_admission: 1
        },
      });
    };
    this.getServiceAgreement();
  },
  methods: {
    recordEnterPurchasePage() {
      enterPurchaseDynamic(this.seriesId).then((res) => {
        console.log(res);
      });
    },

    amountPerPeriod(fqNum) {
      // 花呗免息每期应还金额
      let ret = 0;
      if (this.seriesData.installment && this.seriesData.installment.enable) {
        // 双十一专用，指定开启12期分期
        ret = `${(Math.floor((this.realPayMoney * 100) / fqNum) / 100).toFixed(2)}`;
      }
      return ret;
    },
    // 获取训练营协议链接
    getServiceAgreement() {
      // eslint-disable-next-line camelcase
      serviceAgreement(this.seriesId).then((res) => {
        this.agreementUrl = res.agreement_url;
      });
    },
    // 获取课程详情
    querySeriesDetail() {
      // eslint-disable-next-line camelcase
      const sale_link_id = this.salelinkId || 0;
      getLessonSeriesDetail_v4_0(this.seriesId, sale_link_id).then((res) => {
        this.seriesData = res;
      });
    },
    queryUserViewData() {
      getUserViewData(this.seriesId).then((res) => {
        console.log('viewdata-resdata', res.data);
        this.userViewData = res.data;
      });
    },
    queryVouchers() {
      getLessonVoucher(this.seriesId).then((res) => {
        console.log('voucher-data', res);
        let maxMoney = 0;
        let maxVoucher = null;
        res.items.forEach((item) => {
          item.show_deadline_date = this.getVoucherDeadline(item);
          item.show_desc = this.getVoucherDesc(item);
          item.show_title = this.getVoucherTitle(item);
        });
        this.vouchers = res.items;

        this.vouchers.forEach((item) => {
          if (item.discount_money > maxMoney) {
            maxMoney = item.discount_money;
            maxVoucher = item;
          }
        });
        if (maxVoucher) {
          this.currentVoucher = maxVoucher;
        }
      });
    },
    formatDate(strDate) {
      if (strDate) {
        return strDate.slice(0, 10).replace(/-/g, '.');
      }
      return '';
    },
    getVoucherDeadline(voucher) {
      const startTime = voucher.valid_start_time ? voucher.valid_start_time : voucher.create_time;
      if (!voucher.expire_time && startTime) {
        return `∙ ${this.formatDate(startTime)} 开始生效`;
      } if (!startTime && voucher.expire_time) {
        return `∙ 有效期至 ${this.formatDate(startTime)}`;
      } if (startTime && voucher.expire_time) {
        return `∙ ${this.formatDate(startTime)} - ${this.formatDate(voucher.expire_time)}`;
      }
      return '';
    },
    getVoucherDesc(voucher) {
      let ret = '∙ ';

      if (voucher.voucher_type === INVITE_VOUCHER_TYPE) {
        if (voucher.is_valid) {
          ret += '已激活';
        } else {
          ret += voucher.voucher_desc;
        }
      } else if (voucher.flags === GENERAL_VOUCHER_FLAG) {
        ret += '全场通用';
      } else if (voucher.flags === APP_VOUCHER_FLAG) {
        ret += '仅限app可用';
      } else if (voucher.flags === VIP_VOUCHER_FLAG) {
        ret += '仅限会员可用';
      } else if (voucher.flags === APP_VIP_VOUCHER_FLAG) {
        ret += '仅限会员可用 | 仅限app可用';
      } else if (voucher.flags === TRAINING_VOUCHER_FLAG) {
        ret += '仅限购买训练营可用';
      } else {
        ret += '不能叠加使用';
      }

      if (voucher.activity_name) {
        ret += `（${voucher.activity_name}）`;
      }
      return ret;
    },
    getVoucherTitle(voucher) {
      let ret = '';

      if (voucher.object_id && voucher.lesson_series && voucher.lesson_series.id) {
        ret += `可购买「${voucher.lesson_series.name}」`;
      } else {
        ret += voucher.name;
      }

      return ret;
    },
    selectVoucher(voucher) {
      if (!voucher || voucher.id === this.currentVoucher.id) {
        this.currentVoucher = {};
      } else {
        this.currentVoucher = voucher;
      }
      this.showVouchersDialog = false;
      if (this.currentPayType === MONEY_TYPE_HUABEI && this.realPayMoney < 2000) {
        this.currentPayType = MONEY_TYPE_WECHAT;
      }
      if (this.currentPayType === MONEY_TYPE_UNIONPAY_INSTALLMENT && this.realPayMoney < 2000) {
        this.currentPayType = MONEY_TYPE_WECHAT;
      }
    },
    submitPurchase() {
      if (!this.agree && !!this.agreementUrl) {
        Toast('请先同意训练营服务协议');
        return;
      }

      let buyUrl = `/api/lesson/purchase/buy_series?series_id=${this.seriesId}&money_type=${this.currentPayType}&client_money=${this.realPayMoney}`;
      if (this.salelinkId) {
        buyUrl = `${buyUrl}&sale_link_id=${this.salelinkId}`;
      }

      if (this.currentVoucher && this.currentVoucher.id) {
        buyUrl = `${buyUrl}&voucher_ids=${this.currentVoucher.id}`;
      }

      if (this.currentVoucher && this.currentVoucher.hb_fq_nums_12 === true) {
        buyUrl = `${buyUrl}&hb_fq_num=${this.currentFenQi}`;
      }

      if (this.ordering) {
        // 禁止重复点击
        return;
      }

      this.ordering = true;

      this.buy({
        money_type: this.currentPayType,
        api_url: buyUrl,
        onReady: (res = false) => {
          console.log('onReady回调', res);
          this.ordering = false;
        },
        onPaid: () => {
          Toast.clear();
          this.showWithdrawDia = false;

          this.$router.replace({
            name: 'camp-learning',
            params: {
              series_id: this.seriesId
            },
            query: {
              show_admission: 1
            },
          });
        },
        onScanPay: (qrcodeImage, money) => {
          this.qrcodeImage = qrcodeImage;
          this.money = money;
          this.showWithdrawDia = true;
        }
      });
    },
  },
  beforeDestroy() {
    if (isIos()) {
      // eslint-disable-next-line no-undef
      wx.showAllNonBaseMenuItem();
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';
.camp-payment-pagearea {
  padding 16px
}
.wrapper {
  width: 100%;
  margin-bottom 12px
  background: #FFFFFF;
  border-radius: 8px;
}
.series-data-box {
  position relative
  padding 16px 16px 16px 88px
  .name {
    width 100%
    height 34px
    font-size: 18px;
    font-weight: 600;
    color: $color-text;
    line-height: 34px;
    no-wrap()
  }
  .num-nd-date {
    width: 100%;
    height: 28px;
    margin-top 13px
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 28px;
  }
  .cover-zone {
    position absolute
    top 16px
    left 16px
    width: 60px;
    height: 75px;
    background: #FFC650;
    border-radius: 4px;
    overflow hidden
    .cover-img {
      width 100%
      height 100%
      object-fit cover
    }
  }
}
.price-wrapper {
  padding 0 16px 24px
  .common {
    display flex
    align-items center
    justify-content space-between
    height: 56px;
    border-bottom .5px solid #E7E7E7
    .subs {
      font-size: 14px;
      font-weight: 500;
      color: $color-text;
    }
    .order-info {
      font-size: 14px;
      font-weight: 400;
      color: $color-text;
      &.normal-price {

      }
      &.discount {
        color: #FC5244;
      }
      &.voucher {
        display inline-flex
        align-items center
        color: #FC5244;
        &.no-use {
          color: rgba(25, 25, 25, .44);
        }
        &::after {
          content ''
          display block
          width 12px
          height 12px
          margin-left 2px
          background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYBAMAAAAWrPD2AAAAIVBMVEUAAACVlZWbm5uZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZntH403AAAACnRSTlMADCGqrK2xw9nhFCoieAAAAC5JREFUGNNjYMACmBOReRzLBZB4TLMKkSU16SPpgMILwKUS1RSqS6GGBGooQQEAiwwTd/e/XRQAAAAASUVORK5CYII=') center no-repeat
          background-size cover
        }
      }
    }
  }
  .real-pay {
    margin-top 16px
    font-size: 14px;
    font-weight: 400;
    color: $color-text;
    text-align right
    .real-pay-money {
      font-size: 24px;
      font-weight: 600;
      color: #FC5244;
      line-height: 24px;
      &::before {
        content '￥'
        font-size: 14px;
        font-weight: 500;
        color: #FC5244;
      }
    }
  }
}
.payment-type-wrapper {
  margin-bottom 140px
  .item {
    position relative
    width 100%
    // height: 56px;
    padding 0 16px 0 63px
    background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAMAAABAUVr7AAAAY1BMVEUAAADMzMzU1NTb29vq6urk5OTe3t7f39/c3Nzd3d3d3d3b29vZ2dnd3d3c3Nza2tra2tra2trb29va2trb29va2tra2tra2tra2trb29va2tra2tra2tra2trb29va2tra2tr4uqhgAAAAIHRSTlMABQYHDBMXGCQmLTg8PFd1iZmbq7/Ax8jd4ur0+Pn9/kcaIAIAAADhSURBVDjLjZTHEoMwEEOFAQOhV9PR/39lDkkIBJxZ3TzzvN4mAwd5WWnGeR5NmXm4U1hN3DVV4QVwi4Vrm6daKZ3m7cqlcM9E0HGro+85qjd2wZF4DOzj86W45/A4xBjY+L9P+w2HPY7bsXGu+TsNu08+BXv/rka/Z/Gudtni2zYg3pZX7RVrWFSzAgBvWiMbEq2TByBjC6taZgBK5nYkZwnAMLEjCQ2AkdqOaI4AZio7ojjLEMFDf9NNaWRFC1onGIBgjJJlEKyUZDEF6y0xicRqu2ETrZRObg0rsb3983gCNgoXcISdK9gAAAAASUVORK5CYII=') top 20px right 16px no-repeat
    background-size 16px
    font-size: 14px;
    font-weight: 500;
    color: $color-text;
    &.selected {
      background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAMAAABAUVr7AAAAflBMVEUAAAD/kkn/lUD/lUD/lUf/mUT/lUb/l0X/lkT/lkX/lkX/lkX/lkX/lkX/lkX/lkX/l0X/lkX/l0j/mk3/m07/nFD/n1X/pF7/snj/tn7/vIn/vYv/voz/vo3/v4//wJD/xJj/2Ln/5ND/6Nf/7N//7uH/7+P//v3//v7///+GXZW0AAAAEXRSTlMABwwYJC1XiZmbx8ji6vT4+TH0AcAAAADwSURBVDjLjdRXEoQgDABQewFbtri9u8X7X3AhIhbAIT8y+gZICDrOKLwooXlZ5jSJPEcXQVqAjCINFODGFUyiit2p8AkoQfyxCDPQRBaO5tAKZuQ8LgFDkH4/MRgjFtlW2q+Xz57l1eWeasX1177ZI8WaFgbxPfIa8jpHJnHCUcRIsiggYYQuCqCM5IsCckZKPlgdNnoBZU8e7Wsr3t0mAgku9Gx7MxO4EG63boTh4jzeGJVJC6MITFqUDs1dEVi6/gC4aRWBByCPkZu56I5xaIa6UYRohqGl1jtDS9k0pkV721wSm6tmc2Ftrr355/EHiUc8N0lkIHcAAAAASUVORK5CYII=') top 20px right 16px no-repeat
      background-size 16px
    }

    &>span {
      line-height 56px
    }
    &::before {
      content ''
      display block
      position absolute
      top 16px
      left 16px
      width 39px
      height 24px
      margin-right 4px
    }
    &.wechat::before {
      background url('../../assets/pay_icon_wechat.png') center no-repeat
      background-size 24px 24px
    }
    &.alipay::before {
      background url('../../assets/pay_icon_alipay.png') center no-repeat
      background-size 24px 24px
    }
    &.huabei::before {
      background url('../../assets/pay_icon_huabei.png') center no-repeat
      background-size 24px 24px
    }
    &.huabei {
      .detail {
        display none
      }
      .fenqi {
        width 110px;
        height 50px;
        display inline-block;
        border-radius 5px;
        background-color #f6f7fa;
        div {
          margin 8px 0 0 15px;
          color #191919;
        }
        &.selected {
          border 2px solid #f8b144;
        }
      }
      &.selected {
        .detail {
          display block
          margin-top: -6px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          padding-bottom 16px
          span {
            color: #FC5244;
          }
        }
      }
    }
    &.unionpay::before {
      background url('../../assets/pay_icon_unionpay.png') center no-repeat
      background-size 39px 24px
    }
    &.unionpay {
      .detail {
        display none
      }
      &.selected {
        .detail {
          display block
          margin-top: -6px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          padding-bottom 16px
          span {
            color: #FC5244;
          }
        }
      }
    }

  }
}
.page-footer {
  position fixed
  left 0
  right 0
  bottom 0
  width 100%
  max-width 640px
  margin auto
  .service-agreement {
    display flex
    align-items center
    width: 100%;
    height: 36px;
    background: #FFFFFF;
    padding-left 16px
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    &::before {
      content ''
      display block
      width 12px
      height 12px
      margin-right 6px
      background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAMAAABAUVr7AAAAY1BMVEUAAADMzMzU1NTb29vq6urk5OTe3t7f39/c3Nzd3d3d3d3b29vZ2dnd3d3c3Nza2tra2tra2trb29va2trb29va2tra2tra2tra2trb29va2tra2tra2tra2trb29va2tra2tr4uqhgAAAAIHRSTlMABQYHDBMXGCQmLTg8PFd1iZmbq7/Ax8jd4ur0+Pn9/kcaIAIAAADhSURBVDjLjZTHEoMwEEOFAQOhV9PR/39lDkkIBJxZ3TzzvN4mAwd5WWnGeR5NmXm4U1hN3DVV4QVwi4Vrm6daKZ3m7cqlcM9E0HGro+85qjd2wZF4DOzj86W45/A4xBjY+L9P+w2HPY7bsXGu+TsNu08+BXv/rka/Z/Gudtni2zYg3pZX7RVrWFSzAgBvWiMbEq2TByBjC6taZgBK5nYkZwnAMLEjCQ2AkdqOaI4AZio7ojjLEMFDf9NNaWRFC1onGIBgjJJlEKyUZDEF6y0xicRqu2ETrZRObg0rsb3983gCNgoXcISdK9gAAAAASUVORK5CYII=') center no-repeat
      background-size cover
    }
    .link {
      color $color-text
    }
    &.selected {
      &::before {
        background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABUUExURUxpcf+XRv+WRf+WRf+WRf+XRf+2SP+WRf+fSv+XRf+qVf+WR/+bSP+ZSf+WRf////++jP/AkP/q2f/t3/+fVf+cTv+ydv/bwP+8iP+hWP/+/v/FmPF9MgIAAAAOdFJOUwCC2b/jxwfzGJYGRy4tlz1JGwAAAMtJREFUeNqFk9EOgjAMRcsGdN30giio+P//abSRBQvsvp7TrMluKScm8Y7ZeUmRbIIwlrCEP9xWirNStavxBiZNyPxUYyP1eZlXbo2gvG2wk0b3qLCb6vsAb7J+mAD+PCKb/DJ3AwAhirzD5wcAjpT2eI9PEskhh5A/5PDkDjkc6Y7TuM3BKty7YbRcBaeCGobD6ZK3qxqGw5MgG5ZDKCEbL8ORKHI2OsM56mepYTlEv/tnGM5hXZinKUyxcqXSFmtfPpzy6ZWPt3j+b9NRLZiQ/FDfAAAAAElFTkSuQmCC') center no-repeat
        background-size cover
      }
    }
  }
  .pay-btn {
    padding 5px 16px 4px
    background #fff
    .text {
      display block
      width 100%
      height: 40px;
      background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
      border-radius: 6px;
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
      text-align center
    }
  }
}
.withdraw-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .withdraw-box {
    background #fff
    position relative
    width 78.667%
    max-width 295px
    border-radius 5px
    .tell {
      height: 50px;
      text-align: center;
      line-height: 50px;
      font-weight: 500;
      font-size: 15px;
      color: #404040;
      border-radius: 5px;
      background-color: #f2f2f2;
    }
    .money {
      margin-top 20px
      font-size: 15px;
      color: #404040;
      line-height: 20px;
      font-weight: 400;
      text-align: center;
      .num {
        color #ff4c52
      }
    }
    .qrcode {
      display flex
      align-items center
      justify-content center
      width 100%
      padding 20px 24px
    }
  }
}
.vouchers-dialog {
  background-color: #F7F7F7;

}
.voucher-list {
  background-color: #F7F7F7;
  .v-item {
    position: relative;
    margin: 16px;
    .single-voucher-wrap {
      padding: 15px 40px 15px 15px;
      background-color: #fff;
      border-radius: 4px;
      font-size: 16px;
      color: #191919;
      font-weight: 500;
      line-height: 20px;
      white-space: nowrap;
      -ms-text-overflow: ellipsis;
      text-overflow: ellipsis;
      overflow: hidden;
      .use-date {
        display: block;
        margin-top: 5px;
        white-space: nowrap;
        -ms-text-overflow: ellipsis;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 12px;
        color: rgba(25, 25, 25, .44);
      }
      .icon-select {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 15px;
        margin: auto;
        display: block;
        width: 22px;
        height: 22px;
        background: transparent url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAMAAABAUVr7AAAAY1BMVEUAAADMzMzU1NTb29vq6urk5OTe3t7f39/c3Nzd3d3d3d3b29vZ2dnd3d3c3Nza2tra2tra2trb29va2trb29va2tra2tra2tra2trb29va2tra2tra2tra2trb29va2tra2tr4uqhgAAAAIHRSTlMABQYHDBMXGCQmLTg8PFd1iZmbq7/Ax8jd4ur0+Pn9/kcaIAIAAADhSURBVDjLjZTHEoMwEEOFAQOhV9PR/39lDkkIBJxZ3TzzvN4mAwd5WWnGeR5NmXm4U1hN3DVV4QVwi4Vrm6daKZ3m7cqlcM9E0HGro+85qjd2wZF4DOzj86W45/A4xBjY+L9P+w2HPY7bsXGu+TsNu08+BXv/rka/Z/Gudtni2zYg3pZX7RVrWFSzAgBvWiMbEq2TByBjC6taZgBK5nYkZwnAMLEjCQ2AkdqOaI4AZio7ojjLEMFDf9NNaWRFC1onGIBgjJJlEKyUZDEF6y0xicRqu2ETrZRObg0rsb3983gCNgoXcISdK9gAAAAASUVORK5CYII=') center center no-repeat;
        background-size: 22px;
      }
      &.on {
        .icon-select {
          position: absolute;
          top: 0;
          bottom: 0;
          right: 15px;
          margin: auto;
          display: block;
          width: 22px;
          height: 22px;
          background: transparent url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAMAAABAUVr7AAAAflBMVEUAAAD/kkn/lUD/lUD/lUf/mUT/lUb/l0X/lkT/lkX/lkX/lkX/lkX/lkX/lkX/lkX/l0X/lkX/l0j/mk3/m07/nFD/n1X/pF7/snj/tn7/vIn/vYv/voz/vo3/v4//wJD/xJj/2Ln/5ND/6Nf/7N//7uH/7+P//v3//v7///+GXZW0AAAAEXRSTlMABwwYJC1XiZmbx8ji6vT4+TH0AcAAAADwSURBVDjLjdRXEoQgDABQewFbtri9u8X7X3AhIhbAIT8y+gZICDrOKLwooXlZ5jSJPEcXQVqAjCINFODGFUyiit2p8AkoQfyxCDPQRBaO5tAKZuQ8LgFDkH4/MRgjFtlW2q+Xz57l1eWeasX1177ZI8WaFgbxPfIa8jpHJnHCUcRIsiggYYQuCqCM5IsCckZKPlgdNnoBZU8e7Wsr3t0mAgku9Gx7MxO4EG63boTh4jzeGJVJC6MITFqUDs1dEVi6/gC4aRWBByCPkZu56I5xaIa6UYRohqGl1jtDS9k0pkV721wSm6tmc2Ftrr355/EHiUc8N0lkIHcAAAAASUVORK5CYII=') center center no-repeat;
          background-size: 22px;
        }
      }
    }
    .v-bg-zone {
      position: relative;
      width: 100%;
      padding-bottom: 29.74%;
      background-color: transparent;
      &::before {
        content: '';
        position: absolute;
        top: 7%;
        left: .8%;
        right: .8%;
        bottom: 7%;
        display: block;
        background-color: transparent;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
      }
      &.not-box-shadow::before {
        content: '';
        display: none;
        background-color: transparent;
        box-shadow: none;
      }
      .monitor-only {
        position: absolute;
        z-index: 1;
        top: -10%;
        left: -3%;
        width: 19%;
      }
      .v-bg-img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .single-voucher-wrapper {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 2;
      display: flex;
      -ms-align-items: center;
      align-items: center;
      justify-content: center;
      .v-left-wrap {
        display: flex;
        -ms-align-items: center;
        align-items: center;
        justify-content: center;
        -webkit-flex-direction: column;
        -moz-flex-direction: column;
        -ms-flex-direction: column;
        -o-flex-direction: column;
        flex-direction: column;
        width: 30%;
        .voucher-value {
          height: 36px;
          line-height: 36px;
          color: #ff4c52;
          font-size: 24px;
          .num {
            font-size: 36px;
            font-weight: 500;
          }
        }
        .text-valid {
          margin-top: 2px;
          width: 52px;
          height: 18px;
          border-radius: 13px;
          background-color: rgba(153, 153, 153, 1);
          line-height: 12px;
          line-height: 18px;
          color: rgba(255, 255, 255, 1);
          font-size: 12px;
          text-align: center;
        }
      }
      .v-right-zone {
        flex: 1 1 auto;
        width: 1%;
        overflow: hidden;
        padding: 10px 25px 10px 12px;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          right: 10px;
          margin: auto;
          display: block;
          width: 12px;
          height: 12px;
          background: transparent url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAMAAABAUVr7AAAAY1BMVEUAAADMzMzU1NTb29vq6urk5OTe3t7f39/c3Nzd3d3d3d3b29vZ2dnd3d3c3Nza2tra2tra2trb29va2trb29va2tra2tra2tra2trb29va2tra2tra2tra2trb29va2tra2tr4uqhgAAAAIHRSTlMABQYHDBMXGCQmLTg8PFd1iZmbq7/Ax8jd4ur0+Pn9/kcaIAIAAADhSURBVDjLjZTHEoMwEEOFAQOhV9PR/39lDkkIBJxZ3TzzvN4mAwd5WWnGeR5NmXm4U1hN3DVV4QVwi4Vrm6daKZ3m7cqlcM9E0HGro+85qjd2wZF4DOzj86W45/A4xBjY+L9P+w2HPY7bsXGu+TsNu08+BXv/rka/Z/Gudtni2zYg3pZX7RVrWFSzAgBvWiMbEq2TByBjC6taZgBK5nYkZwnAMLEjCQ2AkdqOaI4AZio7ojjLEMFDf9NNaWRFC1onGIBgjJJlEKyUZDEF6y0xicRqu2ETrZRObg0rsb3983gCNgoXcISdK9gAAAAASUVORK5CYII=') center center no-repeat;
          background-size: 12px;
        }
        &.series-select {
          position: relative;
          padding: 10px 40px 10px 12px;
          &::before {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            right: 15px;
            margin: auto;
            display: block;
            width: 22px;
            height: 22px;
            // background: transparent url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAMAAABAUVr7AAAAflBMVEUAAAD/kkn/lUD/lUD/lUf/mUT/lUb/l0X/lkT/lkX/lkX/lkX/lkX/lkX/lkX/lkX/l0X/lkX/l0j/mk3/m07/nFD/n1X/pF7/snj/tn7/vIn/vYv/voz/vo3/v4//wJD/xJj/2Ln/5ND/6Nf/7N//7uH/7+P//v3//v7///+GXZW0AAAAEXRSTlMABwwYJC1XiZmbx8ji6vT4+TH0AcAAAADwSURBVDjLjdRXEoQgDABQewFbtri9u8X7X3AhIhbAIT8y+gZICDrOKLwooXlZ5jSJPEcXQVqAjCINFODGFUyiit2p8AkoQfyxCDPQRBaO5tAKZuQ8LgFDkH4/MRgjFtlW2q+Xz57l1eWeasX1177ZI8WaFgbxPfIa8jpHJnHCUcRIsiggYYQuCqCM5IsCckZKPlgdNnoBZU8e7Wsr3t0mAgku9Gx7MxO4EG63boTh4jzeGJVJC6MITFqUDs1dEVi6/gC4aRWBByCPkZu56I5xaIa6UYRohqGl1jtDS9k0pkV721wSm6tmc2Ftrr355/EHiUc8N0lkIHcAAAAASUVORK5CYII=') center center no-repeat;
            background-size: 22px;
          }
          &.on::before {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            right: 15px;
            margin: auto;
            display: block;
            width: 22px;
            height: 22px;
            background: transparent url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAMAAABAUVr7AAAAflBMVEUAAAD/kkn/lUD/lUD/lUf/mUT/lUb/l0X/lkT/lkX/lkX/lkX/lkX/lkX/lkX/lkX/l0X/lkX/l0j/mk3/m07/nFD/n1X/pF7/snj/tn7/vIn/vYv/voz/vo3/v4//wJD/xJj/2Ln/5ND/6Nf/7N//7uH/7+P//v3//v7///+GXZW0AAAAEXRSTlMABwwYJC1XiZmbx8ji6vT4+TH0AcAAAADwSURBVDjLjdRXEoQgDABQewFbtri9u8X7X3AhIhbAIT8y+gZICDrOKLwooXlZ5jSJPEcXQVqAjCINFODGFUyiit2p8AkoQfyxCDPQRBaO5tAKZuQ8LgFDkH4/MRgjFtlW2q+Xz57l1eWeasX1177ZI8WaFgbxPfIa8jpHJnHCUcRIsiggYYQuCqCM5IsCckZKPlgdNnoBZU8e7Wsr3t0mAgku9Gx7MxO4EG63boTh4jzeGJVJC6MITFqUDs1dEVi6/gC4aRWBByCPkZu56I5xaIa6UYRohqGl1jtDS9k0pkV721wSm6tmc2Ftrr355/EHiUc8N0lkIHcAAAAASUVORK5CYII=') center center no-repeat;
            background-size: 22px;
          }
        }
        .voucher-name {
          min-height: 20px;
          max-height: 40px;
          line-height: 20px;
          color: rgba(0, 0, 0, 1);
          font-size: 15px;
          text-align: left;
          font-weight: 500;
          multi-line(2)
        }
        .vocher-info-zone {
          margin-top: 6px;
          display: block;
          line-height: 16px;
          color: rgba(153, 153, 153, 1);
          font-size: 12px;
          text-align: left;
          .i-item {
            height: 16px;
            no-wrap()
          }
        }
      }
      &.no-valid::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        width: 64px;
        height: 46px;
        background: transparent url() center center no-repeat;
        -webkit-background-size: 64px 46px;
        background-size: 64px 46px;
      }
    }
  }
}
@media screen and (max-width: 374px) {
  .single-voucher-wrapper .v-right-zone .voucher-name {
    min-height: 16px;
    max-height: 32px;
    line-height: 16px;
    font-size: 13px;
  }
}
</style>
